import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase/app'
import 'firebase/auth';
import vuetify from './plugins/vuetify';
import axios from 'axios'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import VueGtag from "vue-gtag";

Vue.use(VueTheMask)

Vue.use(VueGtag, {
  config: { id: "AW-1049055711" }
});

Vue.config.productionTip = false

const base = axios.create({
  baseURL: 'https://diakportal.csigaver.hu/services'
})

Vue.prototype.$http = base
Vue.prototype.$axios = axios

var config = {
  apiKey: "AIzaSyARAyfGHf7fEsCT-JcA57piQOb2ZBg9wFs",
  authDomain: "csigaportal-de368.firebaseapp.com",
  databaseURL: "https://csigaportal-de368.firebaseio.com",
  projectId: "csigaportal-de368",
  storageBucket: "csigaportal-de368.appspot.com",
  messagingSenderId: "498909395288",
  appId: "1:498909395288:web:f8dc42ca82e2cdbe3ccd2d",
  measurementId: "G-KE6H5QVM6Q"
}

firebase.initializeApp(config)

const FbToken = {
  install(Vue) {
    Vue.prototype.gettoken = async function () {
      await firebase.auth().currentUser.getIdToken().then((idToken) => {
        this.token = idToken
      }).catch((error) => {
        alert(error)
      })
    }
  },
}
Vue.use(FbToken)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
